import { render, staticRenderFns } from "./InvestorApplyDialog.vue?vue&type=template&id=a61eccb8&scoped=true"
import script from "./InvestorApplyDialog.vue?vue&type=script&lang=ts"
export * from "./InvestorApplyDialog.vue?vue&type=script&lang=ts"
import style0 from "./InvestorApplyDialog.vue?vue&type=style&index=0&id=a61eccb8&prod&lang=css"
import style1 from "./InvestorApplyDialog.vue?vue&type=style&index=1&id=a61eccb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a61eccb8",
  null
  
)

export default component.exports